import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

interface User {
  _id: string;
  name: string;
  email: string;
  role: string;
}

interface AuthContextType {
  user: User | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
  }, []);

  // const login = async (email: string, password: string) => {
  //   try {
  //     const response = await axios.post('https://hellogassy-backend.onrender.com/api/users/login', { 
  //       email, 
  //       password 
  //     });
  //     console.log('Login response:', response.data);
      
  //     if (response.data.token != "") {
  //       console.log("cool");
  //       localStorage.setItem('token', response.data.data.token);
  //       console.log(response.data.data);
  //       setUser(response.data.data);
  //       console.log(user);
  //     } else {
  //       throw new Error('Réponse invalide du serveur');
  //     }
  //   } catch (error: any) {
  //     console.error('Login error:', error.response?.data || error.message);
  //     throw new Error(error.response?.data?.message || 'Erreur de connexion');
  //   }
  // };
  const login = async (email: string, password: string) => {
  try {
    const response = await axios.post(
      'https://hellogassy-backend.onrender.com/api/users/login',
      { email, password }
    );
     if (response.data.token != "") {
        console.log("cool");
        localStorage.setItem('token', response.data.data.token);
        
        // console.log(response.data.data);
        setUser(response.data.data);
        console.log(user);
      } else {
        throw new Error('Réponse invalide du serveur');
      }
    console.log('Login response:', response.data);

    const userData = response.data?.data;

    if (!userData || !userData.token) {
      throw new Error("Réponse invalide du serveur");
    }

    // Sauvegarde token + données user (incluant role)
    // localStorage.setItem('token', userData.token);
    localStorage.setItem('user', JSON.stringify(userData));

    // Mise à jour du contexte user
    setUser(userData);

    console.log("User saved:", userData);

    // return userData;

  } catch (error: any) {
    console.error('Login error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Erreur de connexion');
  }
};


  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 